/**
 * Import Lib & assets
 */

import React, { useState, useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */
import { Content__tooltip } from "components/content/content";
import { Form__radio } from "components/form/form";

/**
 * import context
 */
import { AppContext } from "context/appContext";

/**
 * styled components
 */

const Question = styled.div`
  position: relative;
  ${t.mixins.flex({ direction: "column", align: "center" })}
  padding: 0 0 32px 0;
  border-bottom: 1px solid ${t.color.lightGrey};

  ${t.mixins.sm(`
    padding: 35px 42px;
  `)}
`;

const Title = styled.p`
  margin-bottom: 22px;
  ${t.mixins.rem(18, 20)}
  text-align: center;
  font-weight: ${t.font.regular};
  font-family: ${t.font.primary};
  color: ${t.color.primary};

  ${t.mixins.sm(`
    ${t.mixins.rem(13, 12)}
  `)}
`;

const Span = styled.span`

`;

const Radio = styled(Form__radio)`
  ${t.mixins.flex()}
`;

const Tooltip = styled(Content__tooltip)`
  margin-left: 6px;
`;

/**
 * question component is..
 */

const Form__subradio = ({ question }) => {
  const { title, answers, id, tooltip } = question;
  const { setAnswer, userAnswers } = useContext(AppContext);
  return (
    <Question>
      <Title>
        <Span>{title}</Span>
        {tooltip && <Tooltip content={tooltip} />}
      </Title>
      <Radio
        answers={answers}
        updateValue={answer => {
          setAnswer(id, answer);
        }}
        filled={userAnswers[id]}
      />
    </Question>
  );
};
export default Form__subradio;

Form__subradio.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
  /**
      Object containing question specs
      */
  question: PropTypes.shape({}),
};

Form__subradio.defaultProps = {
  style: {},
  question: {},
};

/*
    import Form__subradio from 'components/form/question/Form__subradio'
    <Form__subradio />
  */
